import { createFileRoute } from '@tanstack/react-router'
import { AppearanceTab } from '@/pages/Settings'

export const Route = createFileRoute('/_authenticated/settings/appearance')({
  component: AppearanceTab,
})
